import React from "react";
const NotesContext = React.createContext(null);
export default NotesContext;